import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../SessionChecker/SessionChecker";
import { handleChangeNumberInput } from "../../Inputs/handleKeyDown";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { domain } from "../../Links/Links";
import { getCookie } from "../../../App";

function CodeVerif({ theme }) {
  const [active, setActive] = useState(false);

  const {
    setCodeVerifStatus,
    emailStatus,
    setEmailStatus,
    setCurrentUserEmail,
    currentUserEmail,
  } = useContext(AuthContext);

  const [codeInputError, setCodeInputError] = useState(null);
  const [code2InputError, setCode2InputError] = useState(null);

  const [codeInputValue, setCodeInputValue] = useState("");
  const [code2InputValue, setCode2InputValue] = useState("");

  const { t } = useTranslation();

  const [requestStatus, setRequestStatus] = useState(false);

  useEffect(() => {
    setActive(true);
  }, []);

  return (
    <>
      <div
        className={`shadow ${theme}`}
        onClick={() => {
          setActive(false);
          setTimeout(() => {
            setCodeVerifStatus(false);
          }, 150);
        }}
      ></div>

      <div className={`popupMainDiv noPadding ${theme} ${active && "active"}`}>
        <div className={`popupHeaderDiv ${theme}`}>{t("Confirm Email")}</div>
        <div className="popupContentDiv">
          <div className="inputDiv">
            <div className="labelDiv">
              {t("Enter the code sent your new email") + ' ' + sessionStorage.getItem('email')}
            </div>

            <input
              className={`input ${theme}`}
              onChange={(e) => {
                handleChangeNumberInput(e.target.value, setCodeInputError);

                if (e.target.value.length == 0) {
                  setCodeInputError(false);
                }

                setCodeInputValue(e.target.value);
              }}
            ></input>

            {codeInputError == true && (
              <div className="inputErrorDiv">{t("Code is invalid")}</div>
            )}

            {emailStatus == true && (
              <>
                <div className="labelDiv">
                  {t("Enter the code sent your current email") + ' ' + currentUserEmail}
                </div>

                <input
                  className={`input ${theme}`}
                  onChange={(e) => {
                    handleChangeNumberInput(e.target.value, setCode2InputError);

                    if (e.target.value.length == 0) {
                      setCode2InputError(false);
                    }

                    setCode2InputValue(e.target.value);
                  }}
                ></input>

                {code2InputError == true && (
                  <div className="inputErrorDiv">{t("Code is invalid")}</div>
                )}
              </>
            )}
          </div>

          <button
            className={`submitButton ${theme} ${codeInputError == false && "active"} `}
            onClick={() => {
              if (codeInputError == false) {
                CodeVerifRequest(
                  codeInputValue,
                  code2InputValue,
                  setCodeVerifStatus,
                  setCodeInputError,
                  setCode2InputError,
                  setEmailStatus,
                  setCurrentUserEmail,
                );
              }
            }}
          >
            {requestStatus == true ? (
              <img src="/icons/loading.png" className={`rotate`}></img>
            ) : (
              t("Submit")
            )}
          </button>
        </div>
      </div>
    </>
  );
}

export default CodeVerif;

async function CodeVerifRequest(
  code,
  code2,
  setCodeVerifStatus,
  setCodeInputError,
  setCode2InputError,
  setEmailStatus,
  setCurrentUserEmail,
) {
  const response = await axios.post(
    domain + "/code_verif/",
    { code: code, code2: code2, email: sessionStorage.getItem("email") },
    {
      withCredentials: true,
      headers: {
        "X-CSRFToken": getCookie("csrf_token"),
      },
    },
  );

  if (response.data.code1_is_ivalid) {
    setCodeInputError(true)
  } else if (response.data.code2_is_invalid) {
    setCode2InputError(true)
  }
  else if (response.data.success) {
    setCodeVerifStatus(false);
    setEmailStatus(true);
    setCurrentUserEmail(response.data.email);
    sessionStorage.removeItem("email");
  } else {
    setCodeInputError(true)
    setCode2InputError(true)
  }
}
